import { getApplicantLabelAndValue } from '@exam-center/exam-event-management';
import { type ApplicantGroupType } from '@exam-center/graphql';
import { Box, Flex, ReadonlyField, Text } from '@shared/components';

export interface OptionalInformationReadonlyFieldProps {
  slotProps?: {
    applicantGroup?: {
      code: string;
      type: ApplicantGroupType;
    };
  };
}

export default function OptionalInformationReadonlyField(
  props: Readonly<OptionalInformationReadonlyFieldProps>,
) {
  const { slotProps } = props;

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
      <Box sx={{ width: 240 }}>
        <Text variant='body1Semibold'>ข้อมูลกลุ่มผู้สมัคร</Text>
      </Box>
      <Flex
        sx={{
          gap: (theme) => theme.spacing(4),
          minWidth: '400px',
          flexDirection: 'column',
        }}
      >
        <ReadonlyField
          label='ประเภทกลุ่มผู้สมัคร'
          content={
            getApplicantLabelAndValue(slotProps?.applicantGroup?.type as ApplicantGroupType)
              ?.label ?? '-'
          }
        />
        <ReadonlyField label='รหัสกลุ่มผู้สมัคร' content={slotProps?.applicantGroup?.code ?? '-'} />
      </Flex>
    </Flex>
  );
}
